import { graphql } from "@/graphql/generated/gql";

export const createMunicipalPropertyRegisterMutationDocument = graphql(/* GraphQL */ `
  mutation CreateMunicipalPropertyRegister($input: CreateMunicipalPropertyRegisterInput!) {
    createMunicipalPropertyRegister(input: $input) {
      ...MunicipalPropertyRegisterFields
    }
  }
`);
